import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import CreateTicket from "./CreateTicket";
import TicketUi from "./TicketUi";
import axios from "../axios";
import { useSelector } from "react-redux";
import moment from "moment";
import DeleteTicket from "./DeleteTicket";
import ReopenTicket from "./Reopen";
import ExpandTicket from "./ExpandedTicket";
import { useNavigate } from "react-router-dom";
export default function TicketsMain({ setTicketOpned }) {
  const navigate = useNavigate()
  const [createTicketClicked, setCreateTicketClicked] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [data, setData] = useState({})
  const [refetch, setRefetch] = useState(false);
  const [deleteClick, setDeleteClick] = useState(false);
  const [reopen, setReOpen] = useState(false);
  const [choosedTicket, setChoosedTicket] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [dataFetching, setDataFetching] = useState(false);
  const userId = useSelector((state) => state?.user?.currentUser?.id);
  const loadingRef = useRef(false);
  const lastPageRef = useRef(false);

  const [filter, setFilter] = useState({
    sortBy: -1,
    status: null,
    limit: 20,
    page: 1
  });


  function generateItems(query) {
    const sortedMessages = query.sort(
      (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
    );

    const messagesByDay = {};
    sortedMessages.forEach((message) => {
      const date = new Date(message.created_at);
      const day = new Date(
        Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
      );
      if (messagesByDay[day]) {
        messagesByDay[day].push(message);
      } else {
        messagesByDay[day] = [message];
      }
    });
    return messagesByDay;
  }


  const handelInfiniteScroll = async () => {
    try {
      if (
        (document.getElementById("total-ticket").clientHeight +
          document.getElementById("total-ticket").scrollTop) +
        1.9 >=
        document.getElementById("total-ticket").scrollHeight
      ) {
        if (!loadingRef.current && !lastPageRef.current) {
          setFilter((prevState) => ({ ...prevState, page: prevState.page + 1 }));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };


  // useEffect(() => {
  //   const element = document.getElementById("total-ticket");
  //   if (element) {
  //     element.addEventListener("scroll", handelInfiniteScroll);
  //   }

  //   return () => {
  //     if (element) {
  //       element.removeEventListener("scroll", handelInfiniteScroll);
  //     }
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [filter.page]);

  const fetchStudentTicket = async () => {
    try {
      setData({});
      setDataFetching(true)
      loadingRef.current = true
      let query = {
        'status': filter.status
      }
      let response = await axios.get(`/ticket/getForStudent/${userId}`, {
        params: query
      });
      if (response) {
        let dateWiseData = generateItems(response.data.data);
        const sortedRecord = Object.keys(dateWiseData).sort((a, b) => new Date(b) - new Date(a))
          .reduce((acc, key) => {
            acc[key] = dateWiseData[key];
            return acc;
          }, {})
        setData(sortedRecord);
      }
    } catch (err) { }
    setDataFetching(false);
    loadingRef.current = false
  }


  useEffect(() => {
    try {
      fetchStudentTicket();
    } catch (error) {
      console.log(error)
    }

  }, [filter, userId]);
  return (
    <>
      {!expanded &&
        <div>
          <div className="d-flex justify-content-between mt-4">
            <FormControl style={{ width: "200px" }}>
              <InputLabel id="demo-simple-select-label">Select Type</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Select Type"
                onChange={(e) => {
                  setFilter((prev) => {
                    return {
                      ...prev,
                      status: e.target.value
                    }
                  })
                }}
              >
                <MenuItem value={"pending"}>Open Ticket</MenuItem>
                <MenuItem value={"resolved"}>Resolved Ticket</MenuItem>
                <MenuItem value={"all"}>All</MenuItem>
              </Select>
            </FormControl>
            <div className="d-flex">
              <button
                style={{ width: "40%", marginRight: "20px" }}
                className="mt-2 btn btn-success"
                onClick={() => { fetchStudentTicket(); }}
              >
                Refresh
              </button>
              <button
                style={{ width: "50%", marginRight: "20px" }}
                className="mt-2 btn btn-light creaeQueryBtn"
                onClick={() => { setCreateTicketClicked(true) }}
              >
                Create Ticket
              </button>
            </div>
          </div>
          <div className="col-sm-12 flex-wrap  mt-4 d-flex justify-content-between both_container">
            <div id="total-ticket" className="col-sm-12 orange-scrollBar" style={{ maxHeight: "70vh", overflowY: "scroll", paddingBottom: "10px" }}>
              {
                dataFetching &&
                <div className="w-100 d-flex justify-content-center align-items-center">
                  <img
                    style={{ width: "100px" }}
                    src="/gif/LoaderDot.gif"
                    alt=""
                  />
                </div>
              }
              {
                Object.keys(data).length == 0 && !dataFetching &&
                <div className="w-100 d-flex justify-content-center align-items-center">
                  <span>Ticket Not found.</span>
                </div>
              }
              {

                Object.keys(data).length > 0 && Object.keys(data).map((day, index) => {
                  return (
                    <div key={index}>
                      <span className=" my-3 current_query fw-bold">

                        {moment(day).calendar({
                          sameDay: "[Today]",
                          lastDay: "[Yesterday]",
                          lastWeek: "MMM DD, YYYY ",
                          sameElse: "dddd-MMM DD, YYYY ",
                        })}
                      </span>
                      {data[day]?.map((item, index) => (
                        <TicketUi data={item} setDeleteClick={setDeleteClick} setReOpen={setReOpen} setChoosedTicket={setChoosedTicket} setExpanded={setExpanded} setTicketOpned={setTicketOpned} />
                      ))}

                    </div>
                  )
                })
              }
            </div>
          </div>
          <div className="mb-5">

          </div>

        </div>
      }
      {createTicketClicked && <CreateTicket onclose={() => { setCreateTicketClicked(false) }} refetching={fetchStudentTicket} />}
      {deleteClick && <DeleteTicket data={choosedTicket} close={() => { setDeleteClick(false) }} refetching={fetchStudentTicket} />}
      {reopen && <ReopenTicket data={choosedTicket} close={() => { setReOpen(false) }} refetching={fetchStudentTicket} />}
      {expanded && <ExpandTicket setExpanded={setExpanded} setTicketOpned={setTicketOpned} data={choosedTicket} setRefetch={setRefetch} refetch={refetch} />}
    </>
  )
}

